export const isUserBuyer = (state) => !state.userReducer.owner.is_creator;
export const isUserCreator = (state) => state.userReducer.owner.is_creator;
export const getOwner = (state) => state.userReducer.owner;
export const getUser = (state) => state.userReducer.user;
export const changingPassword = (state) => state.userReducer.isChangePasswordLoading;
export const userSubmitting = (state) => state.userReducer.submitting;
export const userErrors = (state) => state.userReducer.errors;
